<template>
    <div class="uar_tab">
        <ul class="clear">
            <li><router-link :to="{ name:'message.recive'}" :class="{'current': position=='recive'}">收信箱</router-link> </li>
            <li><router-link :to="{ name:'message.send'}" :class="{'current': position=='send'}">发信箱</router-link> </li>
            <li><router-link :to="{ name:'message.system'}" :class="{'current': position=='system'}">系统消息</router-link> </li>
            <li><router-link :to="{ name:'message.write'}" :class="{'current': position=='write'}">写消息</router-link> </li>
        </ul>
    </div>
</template>

<script>
export default {
    props:{
        position:String
    }
};
</script>

<style scoped>
</style>